import * as Sentry from "@sentry/nextjs";
import {excludeGraphQLFetch} from "apollo-link-sentry";

const SENTRY_DSN: string|undefined =
    process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
    dsn: SENTRY_DSN,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.05,
    maxValueLength: 1000,
    beforeBreadcrumb: excludeGraphQLFetch,
    denyUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
    ],
    ignoreErrors: [
        "Can't find variable: fbq",
        "fbq is not defined",
    ],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
});
